import React from 'react';

import { cn } from '../../lib/utils';

const CenteredContentView = ({ children, className, contentClassName }) => {
  return (
    <div className={cn('w-full min-w-0', className)}>
      <div className={cn('mx-auto w-full max-w-2xl', contentClassName)}>{children}</div>
    </div>
  );
};

export default CenteredContentView;
